import { useCallback, useMemo, useState } from "react";
import dashboardCajeroService from "../services/dashboardCajeroService";

export default function useCajeroDashboard() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [centros, setCentros] = useState([]);
  const [cursos, setCursos] = useState([]);
  const [promociones, setPromociones] = useState([]);

  const fetchDashboard = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const payload = await dashboardCajeroService.fetch(params);
      setData(payload);
      setCentros(Array.isArray(payload?.centros) ? payload.centros : []);
      setCursos(Array.isArray(payload?.cursos) ? payload.cursos : []);
      setPromociones(Array.isArray(payload?.promociones) ? payload.promociones : []);
    } catch (err) {
      console.error("Error cargando dashboard cajero", err);
      setError(err?.message || "No se pudo cargar el dashboard");
    } finally {
      setLoading(false);
    }
  }, []);

  const summary = useMemo(
    () => ({
      lastUpdate: data?.lastUpdate || null,
      kpis: data?.kpis || [],
    }),
    [data]
  );

  return {
    data,
    summary,
    loading,
    error,
    centros,
    cursos,
    promociones,
    fetchDashboard,
  };
}
